import { render, staticRenderFns } from "./balance-statistics.vue?vue&type=template&id=927b9490&"
import script from "./balance-statistics.vue?vue&type=script&lang=js&"
export * from "./balance-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports